function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable react/button-has-type */
/* eslint-disable react/sort-comp */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { WDHComponent, onResize } from '../../../../wdh-foundation/wdh';
import { SiteCoreLink, SiteCoreList } from './sitecore-content-parser';
import LanguageSelector from './language-selector';
var DemantHeader = /*#__PURE__*/function (_WDHComponent) {
  function DemantHeader() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'header';
    _classCallCheck(this, DemantHeader);
    return _callSuper(this, DemantHeader, [className]);
  }
  _inherits(DemantHeader, _WDHComponent);
  return _createClass(DemantHeader, [{
    key: "init",
    value: function init(component) {
      var navigation = component.querySelector('.component.navigation ul');
      var linkList = component.querySelector('.component.link-list ul');
      var searchLink = component.querySelector('.component.link a.search');
      var searchFieldSpot = component.querySelector('.component.search-field-spot');
      var languageSelectorSpot = component.querySelector('.component.language-selector-spot');
      var dataResultPage = searchFieldSpot === undefined ? '' : searchFieldSpot.getAttribute('data-result-page');
      this.app = /*#__PURE__*/React.createRef();
      document.querySelector('#content').classList.add('standard-header');
      ReactDOM.render(/*#__PURE__*/React.createElement(DemantHeaderApp, {
        ref: this.app,
        navigation: navigation,
        linkList: linkList,
        searchLink: searchLink,
        dataResultPage: dataResultPage,
        languageSelectorSpot: languageSelectorSpot
      }), component);
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      this.app.current.onScroll(scrollTop);
    }
  }]);
}(WDHComponent);
var ACTIVE_SUBMENU_PARENT = 'active-submenu-parent';
var DemantHeaderApp = /*#__PURE__*/function (_React$Component) {
  function DemantHeaderApp(props) {
    var _this;
    _classCallCheck(this, DemantHeaderApp);
    _this = _callSuper(this, DemantHeaderApp, [props]);
    _this.scrollTop = 0;
    _this.secondLevelAnimateOutTimeout = null;
    _this.assetPath = '/webservices/search.svc/';
    _this.language = $('html').attr('lang');
    _this.homeLink = _this.language !== 'en' ? "/".concat(window.location.pathname.split('/')[1]) : '/';
    _this.state = {
      isDesktop: _this.isDesktop(),
      mobileOpen: false,
      navigation: props.navigation,
      secondLevelNavigationLabel: null,
      secondLevelNavigation: null,
      secondLevelNavigationAnimatingOut: false,
      pageScroll: -1,
      showSearchFieldSpot: false,
      searchFieldInput: '',
      searchSuggestions: [],
      mobileSearch: false
    };
    _this.openMobileMenu = _this.openMobileMenu.bind(_this);
    _this.closeMobileMenu = _this.closeMobileMenu.bind(_this);
    _this.handleBackButtonClick = _this.handleBackButtonClick.bind(_this);
    _this.freezeScrollingOnIOS = _this.freezeScrollingOnIOS.bind(_this);
    _this.updateMobileState = _this.updateMobileState.bind(_this);
    _this.handleMainMenuClick = _this.handleMainMenuClick.bind(_this);
    return _this;
  }
  _inherits(DemantHeaderApp, _React$Component);
  return _createClass(DemantHeaderApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      onResize(function () {
        _this2.updateMobileState();
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll(scrollTop) {
      /* ignore when mobile menu is open,
      because it sets the content to
      position fixed in openMobileMenu, triggering a scroll to 0,
      causing the logic in closeMobileMenu to break */
      if (this.state.mobileOpen) {
        return;
      }
      var activeLink = document.querySelector("a.".concat(ACTIVE_SUBMENU_PARENT));
      if (activeLink) activeLink.classList.remove(ACTIVE_SUBMENU_PARENT);
      var newState = {
        secondLevelNavigation: null,
        secondLevelNavigationAnimatingOut: false,
        pageScroll: -1
      };
      var holdUp = 5;
      if (Math.abs(scrollTop - this.scrollTop) <= holdUp) {
        return;
      }
      if (scrollTop >= this.scrollTop && scrollTop > 50) {
        newState.pageScroll = 1;
      }
      this.setState(newState);
      this.scrollTop = scrollTop;
    }
  }, {
    key: "getSubMenuStyles",
    value: function getSubMenuStyles() {
      var navigationObject = document.querySelector('.header .navigation-container');
      var navigationOffset = navigationObject ? navigationObject.offsetTop : 0;
      return {
        top: "".concat(navigationOffset, "px")
      };
    }
  }, {
    key: "handleMainMenuClick",
    value: function handleMainMenuClick(event) {
      clearTimeout(this.secondLevelAnimateOutTimeout);
      var a = event.target;
      var ul = a.parentElement.querySelector('ul');
      document.querySelectorAll('.header .main-menu a').forEach(function (node) {
        node.classList.remove(ACTIVE_SUBMENU_PARENT);
      });
      if (ul) {
        event.preventDefault();
        if (ul === this.state.secondLevelNavigation && !this.state.secondLevelNavigationAnimatingOut) {
          this.closeSubMenu();
        } else {
          a.classList.add(ACTIVE_SUBMENU_PARENT);
          this.setState({
            secondLevelNavigation: ul,
            secondLevelNavigationAnimatingOut: false,
            secondLevelNavigationLabel: a.textContent
          });
        }
      }
    }
  }, {
    key: "closeSubMenu",
    value: function closeSubMenu() {
      var _this3 = this;
      this.setState({
        secondLevelNavigationAnimatingOut: true
      }, function () {
        _this3.secondLevelAnimateOutTimeout = setTimeout(function () {
          _this3.setState({
            secondLevelNavigation: null,
            secondLevelNavigationAnimatingOut: false
          });
        }, 300);
      });
    }
  }, {
    key: "freezeScrollingOnIOS",
    value: function freezeScrollingOnIOS(event) {
      event.preventDefault();
    }
  }, {
    key: "openMobileMenu",
    value: function openMobileMenu(event) {
      event.preventDefault();
      if (this.state.mobileSearch) {
        this.setState({
          mobileSearch: false
        });
        this.resetSearch();
      } else if (this.state.mobileOpen) {
        this.closeMobileMenu(event);
      } else {
        // this.scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0); TODO. Test if scroll on mobile is still fine. Then delete.
        document.body.style.position = 'fixed';
        document.body.style.top = "".concat(this.scrollTop, "px");
        this.setState({
          mobileOpen: true
        });
      }
    }
  }, {
    key: "closeMobileMenu",
    value: function closeMobileMenu(event) {
      event.preventDefault();
      clearTimeout(this.blockScrollTimeout);
      document.body.style.position = 'static';
      window.scrollTo(0, this.scrollTop);
      this.setState({
        mobileOpen: false,
        secondLevelNavigation: null
      });
    }
  }, {
    key: "handleBackButtonClick",
    value: function handleBackButtonClick(event) {
      event.preventDefault();
      this.closeSubMenu();
    }
  }, {
    key: "updateMobileState",
    value: function updateMobileState() {
      var isDesktop = this.isDesktop();
      if (isDesktop !== this.state.isDesktop) {
        this.setState({
          isDesktop: isDesktop,
          secondLevelNavigation: null,
          secondLevelNavigationAnimatingOut: false,
          secondLevelNavigationLabel: null,
          mobileOpen: false
        });
      }
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width:992px)').matches;
    }
  }, {
    key: "getSearchFieldSpot",
    value: function getSearchFieldSpot() {
      if (this.state.showSearchFieldSpot) {
        return /*#__PURE__*/React.createElement("div", {
          className: "search-field-spot",
          onClick: this.dismissSearchField.bind(this)
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "search-field"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          value: this.state.searchFieldInput,
          onChange: this.onSearchFieldChange.bind(this),
          onKeyPress: this.onSearchFieldKeyPress.bind(this),
          placeholder: $(this.props.searchLink).text()
        }), /*#__PURE__*/React.createElement("div", {
          className: "search-icon",
          onClick: this.navigateToSearchResults.bind(this)
        })), this.getSearchSuggestions()));
      }
    }
  }, {
    key: "dismissSearchField",
    value: function dismissSearchField(e) {
      if (e.target == e.currentTarget) {
        this.resetSearch();
      }
    }
  }, {
    key: "initSearchField",
    value: function initSearchField(e) {
      e.preventDefault();
      if (!this.props.dataResultPage) {
        var searchResultSpotComponent = document.getElementsByClassName('search-result-spot')[0];
        if (searchResultSpotComponent) {
          var searchField = searchResultSpotComponent.getElementsByTagName('input')[0];
          searchField.focus();
        }
      } else {
        this.setState({
          showSearchFieldSpot: true
        }, function () {
          var searchFieldSpot = document.getElementsByClassName('search-field-spot')[0];
          if (searchFieldSpot) {
            var _searchField = searchFieldSpot.getElementsByTagName('input')[0];
            _searchField.focus();
          }
        });
      }
    }
  }, {
    key: "navigateToSearchResults",
    value: function navigateToSearchResults() {
      if (this.state.searchFieldInput != '') {
        var query = "?q=".concat(this.state.searchFieldInput);
        window.location = this.props.dataResultPage + query;
      }
    }
  }, {
    key: "getSearchSuggestions",
    value: function getSearchSuggestions() {
      if (this.state.searchFieldInput.length > 0) {
        if (this.state.searchSuggestions && this.state.searchSuggestions.length > 0) {
          var suggestions = [];
          for (var i = 0; i < this.state.searchSuggestions.length; i++) {
            var suggestion = /*#__PURE__*/React.createElement("div", {
              className: "search-suggestion",
              key: i,
              onClick: this.onSearchSuggestionClick.bind(this, this.state.searchSuggestions[i])
            }, /*#__PURE__*/React.createElement("p", {
              dangerouslySetInnerHTML: {
                __html: this.state.searchSuggestions[i]
              }
            }));
            suggestions.push(suggestion);
          }
          return /*#__PURE__*/React.createElement("div", {
            className: "search-suggestion-container"
          }, suggestions);
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "search-suggestion-container"
        }, /*#__PURE__*/React.createElement("p", null, "No results."));
      }
    }
  }, {
    key: "getSearchSuggestionData",
    value: function getSearchSuggestionData() {
      if (this.state.searchFieldInput.length === 0) {
        return;
      }
      var url = "".concat(this.assetPath, "suggest/").concat(this.state.searchFieldInput, "/").concat(this.language);
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: this.onSearchSuggestion.bind(this),
        error: this.onSearchSuggestionError.bind(this)
      });
    }
  }, {
    key: "initMobileSearchField",
    value: function initMobileSearchField(e) {
      e.preventDefault();
      if (this.state.mobileOpen) {
        this.setState({
          mobileSearch: true
        });

        // Focus field
      }
    }
  }, {
    key: "getMobileSearch",
    value: function getMobileSearch() {
      if (this.state.mobileOpen && this.state.mobileSearch) {
        return /*#__PURE__*/React.createElement("div", {
          className: "search-field-spot"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "search-field"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          value: this.state.searchFieldInput,
          placeholder: $(this.props.searchLink).text(),
          onChange: this.onSearchFieldChange.bind(this),
          onKeyPress: this.onSearchFieldKeyPress.bind(this)
        })), this.getSearchSuggestions()));
      }
    }
  }, {
    key: "resetSearch",
    value: function resetSearch() {
      this.setState({
        showSearchFieldSpot: false,
        searchFieldInput: '',
        searchSuggestions: []
      });
    }
  }, {
    key: "onSearchFieldChange",
    value: function onSearchFieldChange(e) {
      this.setState({
        searchFieldInput: e.target.value
      }, this.getSearchSuggestionData);
    }
  }, {
    key: "onSearchSuggestion",
    value: function onSearchSuggestion(data) {
      this.setState({
        searchSuggestions: data.Suggests
      });
    }
  }, {
    key: "onSearchSuggestionError",
    value: function onSearchSuggestionError(xhr, status, error) {
      console.log(error);
    }
  }, {
    key: "onSearchSuggestionClick",
    value: function onSearchSuggestionClick(suggestion) {
      this.setState({
        searchFieldInput: suggestion
      }, this.navigateToSearchResults);
    }
  }, {
    key: "onSearchFieldKeyPress",
    value: function onSearchFieldKeyPress(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.navigateToSearchResults();
      }
    }
  }, {
    key: "addScrollClassToFixedSubmenu",
    value: function addScrollClassToFixedSubmenu() {
      var fixedSubmenu = document.querySelector('.fixed-submenu');
      var pageScroll = this.state.pageScroll;
      if (this.state.isDesktop && fixedSubmenu && pageScroll === 1) {
        fixedSubmenu.classList.add('adjustedTopPosition');
      } else if (fixedSubmenu && pageScroll === -1) {
        fixedSubmenu.classList.remove('adjustedTopPosition');
      }
    }
  }, {
    key: "calculateIntroBannerTopMargin",
    value: function calculateIntroBannerTopMargin() {
      var fixedSubmenu = document.querySelector('.fixed-submenu');
      var introBannerMargin = document.querySelector('.intro-banner');
      if (this.state.isDesktop && fixedSubmenu) {
        var fixedSubMenuHeight = document.querySelector('.fixed-submenu').clientHeight;
        introBannerMargin.style.marginTop = "".concat(fixedSubMenuHeight, "px");
      } else if (fixedSubmenu) {
        introBannerMargin.style.marginTop = 0;
      }
    }
  }, {
    key: "scrollTopOnMenuClick",
    value: function scrollTopOnMenuClick() {
      var fixedSubmenu = document.querySelector('.fixed-submenu');
      var menuButtonAnchor = document.querySelectorAll('.rich-text .like-button-small [target="_self"]');
      var scrollElement = document.querySelector('HTML');
      if (this.state.isDesktop && fixedSubmenu) {
        var fixedSubMenuHeight = document.querySelector('.fixed-submenu').clientHeight;
        menuButtonAnchor.forEach(function (menuButton) {
          menuButton.onclick = function () {
            setTimeout(function () {
              var scrollTopCurrentVal = scrollElement.scrollTop;
              var scrollTopNewVal = scrollTopCurrentVal - fixedSubMenuHeight - 120;
              scrollElement.scrollTop = scrollTopNewVal;
            }, 0);
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var languageSelectorSpot = this.props.languageSelectorSpot;
      var pageScroll = this.state.pageScroll;
      return /*#__PURE__*/React.createElement("div", {
        className: pageScroll === 1 ? 'scrolling-down' : ''
      }, this.addScrollClassToFixedSubmenu(), this.calculateIntroBannerTopMargin(), this.scrollTopOnMenuClick(), !this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "mobile"
      }, /*#__PURE__*/React.createElement("div", {
        className: "static-logo"
      }, /*#__PURE__*/React.createElement("a", {
        href: this.homeLink
      }, /*#__PURE__*/React.createElement("img", {
        src: "/design/build/demant2019/assets/demant-logo.svg",
        alt: "logo"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "mobile-container ".concat(this.state.mobileOpen ? 'active' : '')
      }, /*#__PURE__*/React.createElement("a", {
        href: this.homeLink
      }, /*#__PURE__*/React.createElement("img", {
        className: "logo",
        src: "/design/build/demant2019/assets/demant-logo-negative.svg",
        alt: "logo"
      })), !!languageSelectorSpot && /*#__PURE__*/React.createElement(LanguageSelector, {
        htmlDivElement: languageSelectorSpot
      }), this.getMobileSearch(), /*#__PURE__*/React.createElement("div", {
        className: "navigation-container ".concat(this.state.secondLevelNavigation ? 'animate-out' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "navigation"
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.state.navigation,
        onClick: this.handleMainMenuClick
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-menu"
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.props.linkList
      }))), this.state.secondLevelNavigation && /*#__PURE__*/React.createElement("div", {
        className: "sub-menu ".concat(this.state.secondLevelNavigationAnimatingOut ? 'animate-out' : ''),
        style: this.getSubMenuStyles()
      }, /*#__PURE__*/React.createElement("div", {
        className: "sub-menu-heading"
      }, this.state.secondLevelNavigationLabel), /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.state.secondLevelNavigation
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement(SiteCoreLink, {
        htmlAnchorElement: this.props.searchLink,
        onClick: this.initMobileSearchField.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        className: "back ".concat(this.state.secondLevelNavigation && !this.state.secondLevelNavigationAnimatingOut ? 'animate-in' : ''),
        onClick: this.handleBackButtonClick
      }, /*#__PURE__*/React.createElement("img", {
        src: "/design/build/demant2019/assets/back@2x.png",
        alt: "Back"
      })))), /*#__PURE__*/React.createElement("button", {
        className: "open ".concat(this.state.mobileOpen ? 'close' : '', " ").concat(this.state.mobileSearch ? 'upper' : ''),
        onClick: this.openMobileMenu
      }, /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", null, "\xA0"))), this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "desktop"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-menu-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logo-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logo"
      }, /*#__PURE__*/React.createElement("a", {
        href: this.homeLink
      }, /*#__PURE__*/React.createElement("img", {
        src: "/design/build/demant2019/assets/demant-logo-negative.svg",
        alt: "logo"
      })))), this.getSearchFieldSpot(), /*#__PURE__*/React.createElement("div", {
        className: "search-container"
      }, /*#__PURE__*/React.createElement(SiteCoreLink, {
        htmlAnchorElement: this.props.searchLink,
        onClick: this.initSearchField.bind(this)
      })), /*#__PURE__*/React.createElement("div", {
        className: "main-menu",
        style: pageScroll === 1 && languageSelectorSpot ? {
          right: '225px'
        } : {}
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.props.navigation,
        onClick: this.handleMainMenuClick
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-menu",
        style: languageSelectorSpot ? {
          right: '225px'
        } : {}
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.props.linkList
      })), !!languageSelectorSpot && /*#__PURE__*/React.createElement(LanguageSelector, {
        htmlDivElement: languageSelectorSpot
      })), this.state.secondLevelNavigation && /*#__PURE__*/React.createElement("div", {
        className: "sub-menu ".concat(this.state.secondLevelNavigationAnimatingOut ? 'animate-out' : '')
      }, /*#__PURE__*/React.createElement(SiteCoreList, {
        htmlUListElement: this.state.secondLevelNavigation
      }))));
    }
  }]);
}(React.Component);
DemantHeaderApp.propTypes = {
  navigation: PropTypes.instanceOf(HTMLUListElement).isRequired,
  linkList: PropTypes.instanceOf(HTMLUListElement).isRequired,
  searchLink: PropTypes.instanceOf(HTMLAnchorElement).isRequired,
  languageSelectorSpot: PropTypes.instanceOf(HTMLDivElement),
  dataResultPage: PropTypes.string.isRequired
};
DemantHeaderApp.defaultProps = {
  languageSelectorSpot: null
};
var header = new DemantHeader();
header.run();